"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EquipmentActivityRecordUpdate = exports.EquipmentActivityRecordQuery = exports.EquipmentActivityRecordCreate = exports.EquipmentActivityRecordTransport = exports.LocationClassLabels = exports.LocationClass = exports.LocationClassConst = exports.LocationClasses = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
/**
 * An array of location classes.
 */
exports.LocationClasses = ['YARD', 'CUSTOMER', 'DISPOSAL_FACILITY', 'MAINTENANCE_OR_REPAIR', 'TRANSIT'];
exports.LocationClassConst = Object.fromEntries(exports.LocationClasses.map((c) => [c, c]));
/**
 * Represents a union of all location classes.
 */
exports.LocationClass = typebox_1.Type.Union(exports.LocationClasses.map((locationClass) => typebox_1.Type.Literal(locationClass)));
/**
 * A record that maps each location class to its label.
 */
exports.LocationClassLabels = {
    YARD: 'Yard',
    CUSTOMER: 'Customer',
    DISPOSAL_FACILITY: 'Disposal Facility',
    MAINTENANCE_OR_REPAIR: 'Maintenance or Repair',
    TRANSIT: 'Transit',
};
/**
 * Represents the transport schema for an equipment activity record.
 */
exports.EquipmentActivityRecordTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    containerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    vehicleID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    locationClass: exports.LocationClass,
    address: typebox_1.Type.Optional(common_1.AddressTransport),
    coordinates: typebox_1.Type.Optional(typebox_1.Type.Object({
        latitude: typebox_1.Type.Number(),
        longitude: typebox_1.Type.Number(),
    })),
    other: typebox_1.Type.Optional(typebox_1.Type.Record(typebox_1.Type.String(), typebox_1.Type.Number())),
    speed: typebox_1.Type.Optional(typebox_1.Type.Number()),
    references: typebox_1.Type.Array(common_1.EntityReference),
    timestamp: typebox_1.Type.String({ format: 'date-time' }),
});
/**
 * Represents the transport schema for creating an equipment activity record.
 * @requires `containerID`, `containerAssignmentID`, or `vehicleID` to be present.
 * @restricts `containerID` and `containerAssignmentID` cannot both be present.
 */
exports.EquipmentActivityRecordCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.EquipmentActivityRecordTransport, ['id', 'containerID', 'vehicleID', 'references']),
    typebox_1.Type.Object({
        references: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.EntityReference)),
        containerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        containerAssignmentID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        vehicleID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    }),
]);
/**
 * Represents the transport schema for querying equipment activity records.
 */
exports.EquipmentActivityRecordQuery = typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        vehicleID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        containerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    }),
]);
/**
 * Represents the transport schema for updating an equipment activity record.
 * This schema is intentionally set to `Never` to indicate that equipment activity records cannot be updated.
 */
exports.EquipmentActivityRecordUpdate = typebox_1.Type.Never();
//# sourceMappingURL=activity-record-transport.js.map